import languages from '@cospired/i18n-iso-languages';
import deLocale from '@cospired/i18n-iso-languages/langs/de.json';
import enLocale from '@cospired/i18n-iso-languages/langs/en.json';
import frLocale from '@cospired/i18n-iso-languages/langs/fr.json';
import itLocale from '@cospired/i18n-iso-languages/langs/it.json';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import type { IMap } from '../interfaces/generic';
import { textResources } from './translations';

// used to translate language ISO code to "German"/"Deutsch"/"Alemain", etc
languages.registerLocale(enLocale);
languages.registerLocale(deLocale);
languages.registerLocale(frLocale);
languages.registerLocale(itLocale);

export const AVAILABLE_LANGUAGES = ['EN', 'DE', 'FR', 'IT'] as const;

export type AvailableLanguage = (typeof AVAILABLE_LANGUAGES)[number];

const languageResources: Record<AvailableLanguage, Record<string, unknown>> = { EN: {}, DE: {}, FR: {}, IT: {} };

const mapTranslationKeysToLanguage = (resources: IMap<string>, namespaceKey: string[] = []) => {
    Object.keys(resources).forEach((translationKey) => {
        const key = namespaceKey.length ? `${namespaceKey.reduce((acc, key) => (acc === '' ? key : `${acc}.${key}`), '')}.${translationKey}` : translationKey;
        const translation = namespaceKey.length
            ? namespaceKey.reduce((acc, key) => (acc ? acc[key] : undefined), textResources)[translationKey]
            : textResources[translationKey];

        if (translation && 'EN' in translation) {
            languageResources.EN[key] = translation.EN;
            languageResources.DE[key] = translation.DE;
            languageResources.FR[key] = translation.FR;
            languageResources.IT[key] = translation.IT;
        } else if (translation) {
            mapTranslationKeysToLanguage(translation, [...namespaceKey, translationKey]);
        }
    });
};

mapTranslationKeysToLanguage(textResources);

// eslint-disable-next-line import/no-named-as-default-member
i18n.use(initReactI18next).init(
    {
        resources: {
            EN: { translation: languageResources.EN },
            DE: { translation: languageResources.DE },
            FR: { translation: languageResources.FR },
            IT: { translation: languageResources.IT },
        },
        fallbackLng: ['EN'],
        detection: {
            checkWhitelist: true,
        },
        debug: false,
        interpolation: {
            escapeValue: false,
        },
    },
    undefined,
);

export default i18n;
